import type { ReactNode } from "react";
import "./VisuallyHidden.scss";

const VisuallyHidden = ({ children }: { children: ReactNode }): JSX.Element => (
	<div className="xui-visually-hidden">{children}</div>
);

export default VisuallyHidden;
